import {React, useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import NriBuddyChatbot from './Chatbot';

const { FiHeart, FiActivity, FiCalendar, FiPhone, FiShield, FiUsers, FiCheckCircle, FiArrowRight, FiClock, FiHome } = FiIcons;

const ParentalCare = () => {


  const [currentIndex, setCurrentIndex] = useState(0);

const handleNext = () => {
  setCurrentIndex((prev) => (prev + 1) % testimonials.length);
};

const handlePrev = () => {
  setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
};
  useEffect(() =>{
    const timer = setInterval(handleNext, 4000);
    return () => clearInterval(timer);
  })

  const getPosition = (index) => {
    const total = services.length;
    const leftIndex = (currentIndex - 1 + total) % total;
    const rightIndex = (currentIndex + 1) % total;
    if (index === currentIndex) return 'active';
    if (index === leftIndex) return 'left';
    if (index === rightIndex) return 'right';
    return '';
  };

  const [isChatbotOpen, setIsChatbotOpen] = useState(false);

  // 2. Functions to open and close the chatbot
  const openChatbot = () => setIsChatbotOpen(true);
  const closeChatbot = () => setIsChatbotOpen(false);

  const services = [
    {
      icon: FiActivity,
      title: 'Health Monitoring',
      description: 'Regular health check-ups and monitoring for your parents',
      features: ['Monthly health assessments', 'Vital signs monitoring', 'Health report sharing', 'Medication tracking']
    },
    {
      icon: FiCalendar,
      title: 'Medical Appointments',
      description: 'Complete medical appointment management and assistance',
      features: ['Doctor appointment booking', 'Transportation to clinics', 'Medical record management', 'Treatment follow-ups']
    },
    {
      icon: FiPhone,
      title: 'Daily Check-ins',
      description: 'Regular communication and wellness checks',
      features: ['Daily phone calls', 'Wellness assessments', 'Emergency contact', 'Family updates']
    },
    {
      icon: FiShield,
      title: 'Emergency Support',
      description: '24/7 emergency response and medical assistance',
      features: ['24/7 helpline', 'Emergency medical response', 'Hospital coordination', 'Family notification']
    },
    {
      icon: FiUsers,
      title: 'Companion Services',
      description: 'Social companionship and daily life assistance',
      features: ['Social interaction', 'Shopping assistance', 'Recreation activities', 'Emotional support']
    },
    {
      icon: FiHome,
      title: 'Home Care',
      description: 'In-home care and daily living assistance',
      features: ['Personal care assistance', 'Meal preparation', 'Housekeeping support', 'Mobility assistance']
    }
  ];



  const careFeatures = [
    {
      icon: FiActivity,
      title: 'Health Tracking',
      description: 'Monitor vital signs, medications, and overall wellness with regular updates to family members.'
    },
    {
      icon: FiPhone,
      title: '24/7 Support',
      description: 'Round-the-clock emergency support and immediate response to any health concerns.'
    },
    {
      icon: FiUsers,
      title: 'Trained Caregivers',
      description: 'Experienced and compassionate caregivers trained in elderly care and emergency response.'
    },
    {
      icon: FiShield,
      title: 'Safety First',
      description: 'Comprehensive safety measures and emergency protocols to ensure complete peace of mind.'
    }
  ];

  const testimonials = [
    {
      name: 'Rajesh Kumar',
      location: 'Singapore',
      text: 'The care team has been wonderful with my mother. The daily updates give me peace of mind knowing she\'s well taken care of.',
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
    },
    {
      name: 'Rajesh Kumar',
      location: 'Singapore',
      text: 'The care team has been wonderful with my mother. The daily updates give me peace of mind knowing she\'s well taken care of.',
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
    },
    {
      name: 'Meera Patel',
      location: 'Dubai, UAE',
      text: 'Excellent service! They helped my father with his medical appointments and the companion services have really improved his mood.',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face'
    }
  ];
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
    const [touchStartX, setTouchStartX] = useState(null);
  
    const nextTestimonial = () => {
      setCurrentTestimonial(prev => (prev + 1) % testimonials.length);
    };
    const prevTestimonial = () => {
      setCurrentTestimonial(prev => (prev - 1 + testimonials.length) % testimonials.length);
    };
  
    useEffect(() => {
      const slideInterval = setInterval(nextTestimonial, 4000);
      return () => clearInterval(slideInterval);
    }, []);
  
    const handleTouchStart = (e) => setTouchStartX(e.touches[0].clientX);
    const handleTouchEnd = (e) => {
      if (touchStartX === null) return;
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (diff > 50) nextTestimonial();
      else if (diff < -50) prevTestimonial();
      setTouchStartX(null);
    };

  return (
    <>
    {/* Embedded CSS for the 3D Carousel. Perfectly scoped to this component. */}
      <style>{`
        .testimonial-carousel-section {
          background: #f9fafb;
          height: 650px; /* Adjusted height for aesthetics */
          display: flex;
          justify-content: center;
          align-items: center;
          padding-top: 4rem;
          padding-bottom: 6rem;
        }
        .carousel-wrapper {
          position: relative;
          width: 90%;
          max-width: 950px;
          height: 350px;
          perspective: 1200px;
        }
        .testimonial-slide {
          position: absolute;
          top: 0;
          left: 50%;
          width: 60%;
          max-width: 550px; /* Slightly adjusted width */
          transform-origin: center center;
          transform-style: preserve-3d;
          opacity: 0;
          transition: all 0.8s ease-in-out;
          filter: blur(8px);
        }
        .testimonial-slide.active { opacity: 1; transform: translateX(-50%) scale(1) rotateY(0deg); filter: none; z-index: 3; }
        .testimonial-slide.left { opacity: 0.6; transform: translateX(-140%) scale(0.85) rotateY(25deg); z-index: 2; }
        .testimonial-slide.right { opacity: 0.6; transform: translateX(40%) scale(0.85) rotateY(-25deg); z-index: 2; }
        .testimonial-card {
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(10px);
          border-radius: 1rem;
          padding: 40px 30px;
          text-align: center;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
          border: 1px solid #e5e7eb;
          position: relative;
          min-height: 250px;
        }
        .testimonial-card img {
          width: 80px; height: 80px; border-radius: 9999px; object-fit: cover;
          position: absolute; top: -40px; left: 50%; transform: translateX(-50%);
          border: 4px solid #fff; box-shadow: 0 4px 10px rgba(0,0,0,0.15);
        }
        .testimonial-author { margin-top: 50px; }
        .testimonial-text { font-size: 1rem; color: #4b5563; margin-top: 1rem; line-height: 1.6; font-style: italic; }
        .stars { margin-top: 1rem; color: #f59e0b; font-size: 1.125rem; }
        .carousel-buttons {
          position: absolute; bottom: -60px; left: 50%; transform: translateX(-50%);
          display: flex; gap: 1.5rem; z-index: 5;
        }
        .carousel-buttons button {
          background: #1f2937; color: #fff; border: none; border-radius: 9999px;
          width: 40px; height: 40px; cursor: pointer; font-size: 18px; transition: background-color 0.3s;
        }
        .carousel-buttons button:hover { background-color: #0E8A6A; }
        @media (max-width: 768px) { .testimonial-slide { width: 85%; } }
      `}</style>
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-emerald-50 to-primary-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <SafeIcon icon={FiHeart} className="text-4xl text-[#0E8A6A]" />
            </div>
            <div className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full text-sm font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200 mb-6">
              <span className="w-2 h-2 rounded-full bg-[#0E8A6A] animate-pulse"></span>
              Pay as you choose the service
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Parental Care Services
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
              Compassionate care and support for your elderly parents and family members. 
              We provide the love, attention, and professional care they deserve while you're away.
            </p>
            <Link
              to="/login"
              className="bg-[#0E8A6A] text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-[#0b6e54] transition-colors inline-flex items-center space-x-2"
            >
              <span>Start Care Service</span>
              <SafeIcon icon={FiArrowRight} className="text-lg" />
            </Link>
          </motion.div>
        </div>
      </section>

      {/* Care Features */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Why Choose Our Parental Care?
            </h2>
            <p className="text-xl text-gray-600">
              We understand the importance of family and provide care with the same love you would
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            {careFeatures.map((feature, index) => (
              <motion.div
                key={feature.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="text-center"
              >
                <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <SafeIcon icon={feature.icon} className="text-2xl text-[#0E8A6A]" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Comprehensive Care Services
            </h2>
            <p className="text-xl text-gray-600">
              Complete support for all aspects of elderly care and daily living
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <motion.div
                key={service.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white rounded-xl shadow-lg border border-gray-200 p-6 hover:shadow-xl transition-shadow"
              >
                <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center mb-4">
                  <SafeIcon icon={service.icon} className="text-2xl text-[#0E8A6A]" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{service.title}</h3>
                <p className="text-gray-600 mb-4">{service.description}</p>
                <ul className="space-y-2">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center space-x-2 text-sm text-gray-700">
                      <SafeIcon icon={FiCheckCircle} className="text-green-500 text-xs flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              How It Works
            </h2>
            <p className="text-xl text-gray-600">
              Simple steps to ensure your parents are always cared for
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {[
              { step: '1', title: 'Initial Consultation', description: 'Discuss health records, dietary requirements, and emotional companionship goals.' },
              { step: '2', title: 'Dedicated Buddy Assigned', description: 'We assign a compassionate, trained local assistant matching their needs.' },
              { step: '3', title: 'Regular Care Visits', description: 'Scheduled home check-ins, medical appointments, and vital monitoring.' },
              { step: '4', title: 'Instant Family Updates', description: 'Stay updated with comprehensive visit logs and reports via our dashboard.' }
            ].map((step, index) => (
              <motion.div
                key={step.step}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-gray-50 rounded-xl p-6 border border-gray-200 shadow-md text-center hover:shadow-lg transition-shadow"
              >
                <div className="w-16 h-16 bg-[#0E8A6A] text-white rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold">
                  {step.step}
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-gray-600 text-sm">{step.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="bg-gray-50 flex justify-center items-center relative overflow-hidden" style={{ height: '650px', paddingTop: '4rem', paddingBottom: '6rem' }}>
        {/* Animated background elements */}
        <motion.div
          animate={{
            scale: [1, 1.2, 1],
            rotate: [0, 90, 0],
          }}
          transition={{
            duration: 20,
            repeat: Infinity,
            ease: "linear"
          }}
          className="absolute top-10 right-10 w-64 h-64 bg-blue-100 rounded-full opacity-20 blur-3xl"
        />
        <motion.div
          animate={{
            scale: [1.2, 1, 1.2],
            rotate: [0, -90, 0],
          }}
          transition={{
            duration: 15,
            repeat: Infinity,
            ease: "linear"
          }}
          className="absolute bottom-10 left-10 w-64 h-64 bg-purple-100 rounded-full opacity-20 blur-3xl"
        />

        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="text-center mb-12"
          >
            <motion.h2
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="text-3xl font-bold text-gray-900 mb-4"
            >
              Families Trust Us
            </motion.h2>
            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="text-xl text-gray-600 max-w-2xl mx-auto"
            >
              See what families say about our parental care services
            </motion.p>
          </motion.div>

          {/* 3D Carousel Container */}
          <div className="relative mx-auto" style={{ width: '90%', maxWidth: '950px', height: '350px', perspective: '1200px' }}>
            {testimonials.map((testimonial, index) => {
              const total = testimonials.length;
              const leftIndex = (currentIndex - 1 + total) % total;
              const rightIndex = (currentIndex + 1) % total;
              
              let positionClass = '';
              let style = {
                position: 'absolute',
                top: 0,
                left: '50%',
                width: '60%',
                maxWidth: '550px',
                transformOrigin: 'center center',
                transformStyle: 'preserve-3d',
                opacity: 0,
                transition: 'all 0.8s ease-in-out',
                filter: 'blur(8px)'
              };

              if (index === currentIndex) {
                // Active/Center card
                positionClass = 'z-30';
                style = { ...style, opacity: 1, transform: 'translateX(-50%) scale(1) rotateY(0deg)', filter: 'none' };
              } else if (index === leftIndex) {
                // Left card
                positionClass = 'z-20';
                style = { ...style, opacity: 0.6, transform: 'translateX(-140%) scale(0.85) rotateY(25deg)', filter: 'blur(2px)' };
              } else if (index === rightIndex) {
                // Right card
                positionClass = 'z-20';
                style = { ...style, opacity: 0.6, transform: 'translateX(40%) scale(0.85) rotateY(-25deg)', filter: 'blur(2px)' };
              }

              return (
                <div key={index} className={positionClass} style={style}>
                  {/* Sticky note container */}
                  <div className="bg-emerald-100 rounded-2xl shadow-2xl p-8 relative" style={{ minHeight: '320px' }}>
                    {/* Quote frame border */}
                    <div className="absolute inset-4 border-2 border-emerald-600/20 rounded-lg">
                      {/* Top quote */}
                      <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 text-5xl font-bold text-[#0E8A6A]">❝</div>
                      {/* Bottom quote */}
                      <div className="absolute -bottom-5 left-1/2 transform -translate-x-1/2 text-5xl font-bold text-[#0E8A6A]">❞</div>
                    </div>

                    {/* Polaroid photo with paper clip}
                    <div className="absolute -top-6 -right-4 bg-white p-2 shadow-xl z-20" style={{ width: '120px', transform: 'rotate(8deg)' }}>
                      {/* Paper clip 
                      <div className="absolute -top-3 right-3 w-6 h-8 border-2 border-gray-600 rounded-t-full" 
                           style={{ borderBottom: 'none', transform: 'rotate(15deg)' }}>
                        <div className="absolute top-0 left-1/2 w-3 h-3 bg-gray-600 rounded-full transform -translate-x-1/2"></div>
                      </div>
                      
                      <img src={testimonial.image} alt={testimonial.name} className="w-full h-28 object-cover" />
                      <div className="bg-white pt-1 text-center">
                        <p className="text-xs text-gray-700">{testimonial.name}</p>
                      </div>
                    </div>

                    {/* Content */}
                    <div className="relative z-10 pt-6 px-4 h-full flex flex-col justify-center">
                      <p className="text-gray-900 text-base leading-snug mb-4 font-medium text-center mt-8">
                        {testimonial.text}
                      </p>

                      {/* Star rating */}
                      <div className="flex justify-center gap-1 mb-3 text-yellow-500">
                        ★★★★★
                      </div>

                      {/* Name and location */}
                      <div className="text-center">
                        <p className="text-sm text-gray-700">
                          <span className="font-bold">{testimonial.name}</span>
                          <br />
                          <span className="text-gray-500 text-xs">{testimonial.location}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}

            {/* Navigation Buttons */}
            <div className="absolute left-1/2 transform -translate-x-1/2 flex gap-6 z-50" style={{ bottom: '-60px' }}>
              <button
                onClick={handlePrev}
                className="bg-gray-800 text-white rounded-full flex items-center justify-center hover:bg-[#0E8A6A] transition-colors duration-300"
                style={{ width: '40px', height: '40px', border: 'none', cursor: 'pointer', fontSize: '18px' }}
                aria-label="Previous testimonial"
              >
                &#10094;
              </button>
              <button
                onClick={handleNext}
                className="bg-gray-800 text-white rounded-full flex items-center justify-center hover:bg-[#0E8A6A] transition-colors duration-300"
                style={{ width: '40px', height: '40px', border: 'none', cursor: 'pointer', fontSize: '18px' }}
                aria-label="Next testimonial"
              >
                &#10095;
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Emergency Support */}
      <section className="py-16 bg-[#0E8A6A]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center text-white"
          >
            <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-6">
              <SafeIcon icon={FiShield} className="text-3xl text-white" />
            </div>
            <h2 className="text-3xl font-bold mb-4">24/7 Emergency Support</h2>
            <p className="text-xl text-emerald-100 mb-8 max-w-2xl mx-auto">
              Our emergency response team is available round-the-clock to handle any urgent situations 
              and provide immediate assistance to your loved ones.
            </p>
            <div className="flex items-center justify-center space-x-4 text-lg">
              <SafeIcon icon={FiPhone} className="text-2xl" />
              <a href="https://wa.me/919618222498" className="hover:underline">Emergency Hotline: +91 9618222498</a>
            </div>
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Give Your Parents the Care They Deserve
            </h2>
            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
              Start with our parental care services today and ensure your loved ones receive
              the attention, care, and support they need while you're away.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              {/*
                3. Update the button to trigger the chatbot.
                   - Changed from <Link> to <button> since it no longer navigates.
                   - Added onClick handler.
              */}
              <button
                onClick={openChatbot} // This function now opens the chatbot
                className="bg-[#0E8A6A] text-white px-8 py-3 rounded-lg font-semibold hover:bg-[#0b6e54] transition-colors"
              >
                Explore Care Service
              </button>
              
              <Link
                to="/login"
                className="border-2 border-[#0E8A6A] text-[#0E8A6A] px-8 py-3 rounded-lg font-semibold hover:bg-emerald-50 transition-colors"
              >
                Sign Up Now
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
      {isChatbotOpen && <NriBuddyChatbot onClose={closeChatbot} />}
    </div>
    </>
  );
};

export default ParentalCare;